<template>
  <b-modal :active.sync="isModalActive" :width="640" scroll="keep">
    <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false"></b-loading>
    <div class="rounded-lg shadow-xl bg-white overflow-hidden border border-gray-200 border-[#E4E6EB]">
      <!-- HEADER sin fondo gris -->
      <header class="flex justify-between items-start flex-wrap gap-2 text-sm font-medium text-gray-800 px-6 py-4 border-b border-[#E4E6EB] uppercase tracking-wide">
        <div class="flex-1 min-w-0">
          <h2 class="break-words whitespace-normal">
            <div><b>Actividades vinculadas al {{ group && group.parent_id ? 'subgrupo' : 'grupo' }}</b></div>
            <div><label><b>Grupo: </b>{{ group ? group.name : '' }}</label></div>
          </h2>
        </div>
        <div class="flex-shrink-0">
          <!-- <b-dropdown aria-role="list" position="is-bottom-left">
            <template #trigger="{ active }">
                <b-button
                    label="Acciones"
                    type="is-primary"
                    icon-pack="fas"
                    size="is-small"
                    :icon-right="active ? 'chevron-up' : 'chevron-down'" />
            </template>
            <b-dropdown-item aria-role="listitem" @click="handleClickAction('scheduled')">Recalcular progreso programado</b-dropdown-item>
            <b-dropdown-item aria-role="listitem" @click="handleClickAction('inspected')">Recalcular progreso inspeccionado</b-dropdown-item>
            <b-dropdown-item aria-role="listitem" @click="handleClickAction('all')">Recalcular todo</b-dropdown-item>
          </b-dropdown> -->
        </div>
      </header>

      <!-- BODY con fondo blanco liso -->
      <div class="px-6 py-5 space-y-4 bg-white">
        <div><label><b>{{ $t('activities') }}</b></label></div>
        <div class="w-full inline-flex pb-3">
          <multiselect
            v-model="activitiesSelected"
            :options="activities"
            :placeholder="$t('activities')"
            :disabled="disabled"
            :multiple="true"
            label="name"
            class="rounded-r-none"
            searchable
            allowEmpty
            :closeOnSelect="false"
            :showLabels="false"
            :loading="processingData"
            track-by="id"
          >
              <!--<span slot="placeholder" class="text-base">-->
              <!--{{ $t('parent_department') }}-->
              <!--</span>-->
              <!-- <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template> -->
              <!-- <template slot="singleLabel" slot-scope="props">
                <img class="option__image" :src="props.option.img" alt="No Man’s Sky">
                <span class="option__desc"><span class="option__title">{{ props.option.title }}</span></span>
              </template> -->
              <!-- <template slot="option" slot-scope="props">
                <div class="option__desc"><span class="option__title">{{ props.option.plannig_code }}</span><span class="option__small">{{ props.option.name }}</span></div>
              </template> -->
          </multiselect>
        </div>
      </div>

      <!-- FOOTER sin fondo gris, solo borde superior -->
      <footer class="px-6 py-4 border-t border-[#E4E6EB] bg-white">
        <div class="w-full flex justify-end space-x-2">
            <v-button v-if="!processingData" @click="linkGroup()" icon="plus">{{ $t('link_group') }}</v-button>
            <v-button v-if="!processingData" color="grey" icon="door-closed" @click="isModalActive = false">{{ $t('close') }}</v-button>

            <v-button-processing v-if="processingData" />
        </div>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import axios from "axios";
import Multiselect from 'vue-multiselect'

export default {
  name: "activity-group-link-modal",

  components: {
    Multiselect
  },

  props: {
    projectId: { type: Number, required: true },
    entityType: { type: String, default: 'project' },
  },

  data() {
    return {
      group: null, // grupo seleccionado

      processingData: false,
      isModalActive: false,
      isLoading: false,

      disabled: false,
      activities: [],
      activitiesSelected: [],
    }
  },

  computed: {
  },

  created() {

  },

  mounted() {

  },

  methods: {

    async getActivities(){
      this.isLoading = true
      const { data } = await axios.get("/api/v2/activities", {'params' : { p : this.projectId, light: 1, group_id: this.group.id, add_without_groups: 1, per_page: 999}});
      this.activities = data.activities;
      // this.activities = data.activities.filter((activity) => { return activity.group_id == null });
      this.activitiesSelected = data.activities.filter((activity) => { return activity.group_id == this.group.id });

      this.isLoading = false
    },

    async getActivityTemplates(){
      this.isLoading = true
      const { data } = await axios.get("/api/v2/activity/templates", {'params' : { p : this.projectId, light: 1, group_id: this.group.id, add_without_groups: 1, per_page: 999}});
      this.activities = data.activities;
      // this.activities = data.activities.filter((activity) => { return activity.group_id == null });
      this.activitiesSelected = data.activities.filter((activity) => { return activity.group_id == this.group.id });

      this.isLoading = false
    },

    async linkGroup() {
      if (!this.activitiesSelected) {
        this.$notify.error(this.$t('empty_field_required', ['DSO']))
        return
      }

      this.processingData = true;

      let activities = [];
      this.activitiesSelected.forEach(activity => {
        activities.push(activity.id);
      });

      let self = this;

      await axios.post(`/api/v2/activity/groups/${this.group.id}/link`, {
        activities: activities,
        entity_type: this.entityType,
      })
      .then(response => {
        let data = response.data
        this.processingData = false;

        if (data && data.success) {
          // reload

          self.$notify.success('success_editing')

        } else if(data && data.msg) {
          self.$notify.error('no_access_permissions')
        } else {
          self.$notify.error('error_saving')
        }
      })
      .catch(error => {
          self.processingData = false;
          if (error.response && error.response.status === 422) {
            //extraemos el primer error de validación
            error.error_msg =
              error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
                ][0];
          }

          // Mostramos el error
          this.$toast.open({
            message: error.error_msg || this.$t("assignment_insert_error"),
            type: "is-danger",
            position: "is-top-right"
          });
      });
    },

    show(data) {
      this.group = data;

      // TODO: refactorizar hacer que solo llame a un method
      if( this.entityType === 'project-template' )
        this.getActivityTemplates();
      else
        this.getActivities();

      this.isModalActive = true;
    },

    hide() {
      this.group = null;

      this.activities = [],
      this.activitiesSelected = [],

      this.isModalActive = false;
    }
  }
};
</script>
<style scoped>
/* Oculta los botones para aumentar los inputs numéricos */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
}
</style>
